import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import setSpacesInText from '@functions/setSpacesInText.ts';

import I from '../types.ts';

const renderCards: I['renderCards'] = function () {
    return (
        <div className="publicExecutorsAbout__cards">
            <div className="publicExecutorsAbout__cardsInner _row">
                {this.cards.map((card, key) => (
                    <div className="publicExecutorsAbout__card" key={key}>
                        <div className="publicExecutorsAbout__cardInner _col">
                            <div className="publicExecutorsAbout__cardIcon">
                                <i className="publicExecutorsAbout__cardIconItem">
                                    <Icon name={card.icon} />
                                </i>
                                <i className="publicExecutorsAbout__cardIconItem _shadow">
                                    <Icon name={card.icon} />
                                </i>
                            </div>
                            <div
                                className="publicExecutorsAbout__cardTitle"
                                dangerouslySetInnerHTML={{
                                    __html: setSpacesInText(card.title),
                                }}
                            />
                            <p
                                className="publicExecutorsAbout__cardDescription"
                                dangerouslySetInnerHTML={{
                                    __html: setSpacesInText(card.content),
                                }}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default renderCards;
